/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluationMetric
 */
export interface EvaluationMetric {
    /**
     * 
     * @type {string}
     * @memberof EvaluationMetric
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationMetric
     */
    type: EvaluationMetricTypeEnum;
}


/**
 * @export
 */
export const EvaluationMetricTypeEnum = {
    Float64: 'FLOAT64',
    String: 'STRING'
} as const;
export type EvaluationMetricTypeEnum = typeof EvaluationMetricTypeEnum[keyof typeof EvaluationMetricTypeEnum];


/**
 * Check if a given object implements the EvaluationMetric interface.
 */
export function instanceOfEvaluationMetric(value: object): value is EvaluationMetric {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function EvaluationMetricFromJSON(json: any): EvaluationMetric {
    return EvaluationMetricFromJSONTyped(json, false);
}

export function EvaluationMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationMetric {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
    };
}

export function EvaluationMetricToJSON(value?: EvaluationMetric | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'type': value['type'],
    };
}

